/** returns Operators List
@return { Array }
*/
export const getOperators = state => {
    return state.operatorsList
}

/** returns operations types List
@return { Array }
*/
export const getOperationsTypesList = state => {
    return state.operationsTypesList
}

/** returns accounts List
@return { Array }
*/
export const getAccounts = state => {
    return state.accounts
}

/** returns accounts List
@return { Array }
*/
export const getProfilesForDropdown = state => {
    return state.profiles.map(ele => {
        return {
            ...ele,
            id: ele.id,
            text: ele.operatorProfileDescription
        }
    })
}

/** returns plafonds and limits List
@return { Array }
*/
export const getPlafondsAndLimits = state => {
    return state.plafondsAndLimits
}
